<div style="width: 100%" class="client-detail">
  <form [formGroup]="clientForm" (ngSubmit)="onSubmit()">

    <div class="form-group">
      <label class="center-block">Type:</label>
      <div class="kind-toolbar">
        @for (item of kinds; track item) {
        <div class="kind-option" [class.active]="clientForm.get('kind').value === item"
          (click)="clientForm.get('kind').setValue(item)">
          {{item}}
        </div>
        }
      </div>
      <!-- Hidden input to maintain form control validity without visual select -->
      <input type="hidden" formControlName="kind">

      @if (submitted && f.kind.errors) {
      <div class="invalid-feedback">
        @if (f.kind.errors.required) {
        <div>Kind required</div>
        }
      </div>
      }
    </div>

    @if (isEducationSelected) {
    <div class="form-group">
      <label class="center-block">School Level:</label>
      <div class="kind-toolbar">
        @for (item of schoolLevel; track item) {
        <div class="kind-option" [class.active]="clientForm.get('school_level').value === item"
          (click)="clientForm.get('school_level').setValue(item)">
          {{item}}
        </div>
        }
      </div>
      <!-- Hidden input to maintain form control validity without visual select -->
      <input type="hidden" formControlName="school_level">

      @if (submitted && f.school_level.errors) {
      <div class="invalid-feedback" style="display: block">
        @if (f.school_level.errors.required) {
        <div>School Level required</div>
        }
      </div>
      }
    </div>
    }

    <div class="form-group">
      <label class="center-block">Name:
      </label>
      <input class="form-control" formControlName="name" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" />
      @if (submitted && f.name.errors) {
      <div class="invalid-feedback">
        @if (f.name.errors.required) {
        <div>Name Required</div>
        }
      </div>
      }
    </div>


    @if (isEducationSelected) {
    <div class="form-group">
      <label>Search for Parent Client:</label>
      <mat-form-field style="width: 100%;padding:0px; background:white;">
        <input style="height: 40px;padding: 5px;" type="text" matInput autocomplete="off" formControlName="search_term"
          [matAutocomplete]="auto" (keyup)="searchForParentClients($event.target.value)">
        <mat-autocomplete #auto="matAutocomplete" class="client-detail-autocomplete" [displayWith]="displayParentClient"
          (optionSelected)="onParentSelected($event)">
          @for (client of parentClients; track client) {
          <mat-option [value]="client">
            {{client.name}}
          </mat-option>
          }
        </mat-autocomplete>
        @if (f.search_term.value && f.search_term.value.length > 1 && !parentClients.length) {
        <mat-hint>No results found. Type at least 3 characters.</mat-hint>
        }
      </mat-form-field>
      <!-- Hidden input to store the actual ID for validation/submission if needed, though patchValue handles it -->
      <input type="hidden" formControlName="parent_client">
    </div>
    }

    <div class="form-group">
      <label class="center-block">Contract Start:
      </label>
      <input type="date" class="form-control" formControlName="contract_start" autocomplete="off"
        [ngClass]="{ 'is-invalid': submitted && f.contract_start.errors }" />
      @if (submitted && f.contract_start.errors) {
      <div class="invalid-feedback">
        @if (f.contract_start.errors.required) {
        <div>Contract start required</div>
        }
        @if (f.contract_start.errors.date) {
        <div>Valid Date Required</div>
        }
      </div>
      }
    </div>

    <div class="form-group">
      <label class="center-block">Contract End:
      </label>
      <input type="date" class="form-control" formControlName="contract_end" autocomplete="off"
        [ngClass]="{ 'is-invalid': submitted && f.contract_end.errors }" />
      @if (submitted && f.contract_end.errors) {
      <div class="invalid-feedback">
        @if (f.contract_end.errors.required) {
        <div>Contract end required</div>
        }
        @if (f.contract_end.errors.date) {
        <div>Valid Date Required</div>
        }
      </div>
      }
    </div>

    <div class="form-group">
      <label class="center-block">Lead/HR emails (comma separated):
      </label>
      <input class="form-control" formControlName="emails" [ngClass]="{ 'is-invalid': submitted && f.emails.errors }" />
      @if (submitted && f.emails.errors) {
      <div class="invalid-feedback">
        @if (f.name.emails.required) {
        <div>Emails error</div>
        }
      </div>
      }
    </div>

    <div class="tags-section">
      <div class="form-group">
        <label class="center-block">Current Tags:</label>
        <div class="tags-container">
          @for (tag of currentTags; track tag.tag) {
            <div class="tag-chip">
              {{tag.tag}}<span class="tag-remove" (click)="removeTag(tag)">×</span>
            </div>
          }
          @if (!currentTags.length) {
            <span class="no-tags-label">No tags applied</span>
          }
        </div>
      </div>
      <div class="form-group">
        <label class="center-block">Add Tags:</label>
        <input
          class="form-control tag-input"
          placeholder="Search or select tags..."
          [(ngModel)]="tagInput"
          [ngModelOptions]="{standalone: true}"
          (keyup.enter)="addNewTag()"
          autocomplete="off"
        />
        <div class="tag-checklist">
          @for (tag of filteredAllTags; track tag.id) {
            <div class="tag-checklist-item" [class.applied]="isTagApplied(tag)" (click)="toggleTag(tag)">
              <mat-icon class="tag-check-icon">{{ isTagApplied(tag) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
              <span>{{ tag.tag }}</span>
            </div>
          }
          @if (canCreateNewTag) {
            <div class="tag-checklist-item tag-create" (click)="addNewTag()">Create "{{ tagInput.trim() }}"</div>
          }
          @if (!filteredAllTags.length && !canCreateNewTag) {
            <div class="tag-checklist-item tag-empty">No tags found</div>
          }
        </div>
      </div>
    </div>










    @if (showAdvanced) {
    <div style="margin-top: 20px;">
      <div class="form-group">
        <label class="center-block">OAuth URL:
        </label>
        <input class="form-control" formControlName="oauthurl"
          [ngClass]="{ 'is-invalid': submitted && f.oauthurl.errors }" />
        @if (submitted && f.oauthurl.errors) {
        <div class="invalid-feedback">
          @if (f.oauthurl.errors.required) {
          <div>URL Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <label class="center-block">OAuth Username:
        </label>
        <input class="form-control" formControlName="username"
          [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
        @if (submitted && f.username.errors) {
        <div class="invalid-feedback">
          @if (f.username.errors.required) {
          <div>Username Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <label class="center-block">OAuth Password:
        </label>
        <input class="form-control" formControlName="password"
          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        @if (submitted && f.password.errors) {
        <div class="invalid-feedback">
          @if (f.password.errors.required) {
          <div>Password Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <label class="center-block">OAUTH Client ID:
        </label>
        <input class="form-control" formControlName="clientid"
          [ngClass]="{ 'is-invalid': submitted && f.clientid.errors }" />
        @if (submitted && f.clientid.errors) {
        <div class="invalid-feedback">
          @if (f.clientid.errors.required) {
          <div>Client ID Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <label class="center-block">OAuth Secret:
        </label>
        <input class="form-control" formControlName="secret"
          [ngClass]="{ 'is-invalid': submitted && f.secret.errors }" />
        @if (submitted && f.secret.errors) {
        <div class="invalid-feedback">
          @if (f.secret.errors.required) {
          <div>URL Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <label class="center-block">xAPI salt:
        </label>
        <input class="form-control" formControlName="salt" [ngClass]="{ 'is-invalid': submitted && f.salt.errors }" />
        @if (submitted && f.salt.errors) {
        <div class="invalid-feedback">
          @if (f.salt.errors.required) {
          <div>xAPI Salt Required</div>
          }
        </div>
        }
      </div>
      <div class="form-group" style="background:red; padding: 7px 10px 12px 7px; border-radius:5px;">
        <label class="center-block">Save oAuth details - do not press this button.</label>
        <div (click)="saveOAuthDetails()" style="float:right;background: yellow;color:black;border: none;"
          class="btn btn-primary">I know what I'm doing.</div>
      </div>
    </div>
    }



    <div style="margin-bottom: 4em;margin-top: 20px;">
      <div style="float:right;">
        <button type="submit" [disabled]="clientForm.pristine && !tagsChanged">
          Save
        </button>
        <button (click)="onCancel()" style="margin-left: 10px;">Cancel</button>
      </div>

      @if (client && client.id) {
      <button (click)="delete()" style="float:left;">
        Delete
      </button>
      }

      @if (client && client.id) {
      <button (click)="archive()" style="margin-left: 10px;float:left;">
        Archive
      </button>
      }

      <div (click)="fetchOAuthDetails()"
        style="float:left; margin-left:10px; cursor: pointer; display: inline-block; padding: 6px 12px; border: 1px solid #ccc; border-radius: 4px; background-color: #f0f0f0;">
        Advanced</div>

    </div>
  </form>
</div>
